const routeConstant = {
  LoadingComp: "/",
  Login: "/Login",
  ShipmentsListing: "/Home/Shipments",
  Dashboard: "/Home/Dashboard",
  Statement: "/Home/Statements",
  BlogSFL: "/sflhome",
  Users: "/Home/Users",
  Schedule: "/Home/RequestQuote",
  SearchResults: "/Home/Shipments/Search",
  AdvSearchResults: "/Home/Shipments/AdvanceSearch",
  SearchShipment: "/SearchShipment",
  SearchShipmentResult: "/SearchShipment/SearchResults",
  ScheduleSearchResult: "/Home/RequestQuote/RequestResult",
  RequestQuote: "/Home/RequestQuote/RequestResult/RequestQuoteForm",
  UpdatePassword: "/UpdatePassword",
  ForgotPassword: "/ForgotPassword",
  ResetPassword: "/ResetPassword/:id",
  Tracking: "/Home/Shipments/Tracking",
  EnquiryDashboard: "/enquiry/dashboard",
  ArchaiveShipments: "/Home/Archaive/Shipments",

  //order route
  REPORTS: "/reports",
  LOGIN: "/Login",

  SYSTEM_LOG: "/system-log",
  CREATE_ORDER: "/create-order/order-specifcs",
  ORDER_LIST: "/orderManagement/order-list",
  CREATE_ORDER_MAIN: "/create-order",
  CREATE_ORDER: "/create-order/order-specifcs",

  LINE_DETAIL: "/create-order/line-details",

  ORDER_PLAN: "/create-order/order-plan",
  DOC_UPLOAD: "/create-order/e-doc-upload",
  CONFIRMATION: "/create-order/confirmation",

  //dashoard list edit routes
  EDIT_CREATE_ORDER_MAIN: "/edit-order",
  // CREATE_ORDER_MAIN_SIDEBAR: "/create-order",
  EDIT_CREATE_ORDER: "/dashboard/edit-order/order-specifcs",
  EDIT_LINE_DETAIL: "/dashboard/edit-order/line-details",
  EDIT_ORDER_PLAN: "/dashboard/edit-order/order-plan",
  EDIT_DOC_UPLOAD: "/dashboard/edit-order/e-doc-upload",
  EDIT_CONFIRMATION: "/dashboard/edit-order/confirmation",

  //order list edit routes
  // LIST_EDIT_CREATE_ORDER_MAIN: "/edit-order",
  // EDIT_ORDER_ORDER: "/dashboard/edit-order/order-specifcs",
  LIST_EDIT_CREATE_ORDER: "/order-list/edit-order/order-specifcs",
  LIST_EDIT_LINE_DETAIL: "/order-list/edit-order/line-details",
  LIST_EDIT_ORDER_PLAN: "/order-list/edit-order/order-plan",
  LIST_EDIT_DOC_UPLOAD: "/order-list/edit-order/e-doc-upload",
  LIST_EDIT_CONFIRMATION: "/order-list/edit-order/confirmation",

  ORDER_DASHBOARD: "/dashboard",
  ORDER_LIST: "/order-list",
  ORDER_LIST_PLACED: "/order-list/placed",
  ORDER_LIST_APPROVED: "/order-list/approved",
  ORDER_LIST_ARCHIVE: "/order-list/archived",
  ORDER_LIST_LOADED: "/order-list/loaded",
  ORDER_LIST_REJECTED: "/order-list/cancelled",
  ORDER_LIST_FULL: "/order-list/details",
  DASH_ORDER_LIST_FULL: "/dashboard/details",
  ORDER_LIST_FULL_LOG: "/order-list/details/log",
  DASH_ORDER_LIST_FULL_LOG: "/dashboard/details/log",
  ORDER_LIST_FULL_MILESTONE: "/order-list/details/milestone",
  ORDER_LIST_FULL_MILESTONE_DASH: "/dashboard/details/milestone",
  SYSTEM_LOG: "/system-log",
  ORDER_MAIN: "/",
  CHAT: "/chat",
  HELP: "/help",
  USERS: "/users",
  CREATE_USER: "/create-users",
  NOTIFICATION: "/notification",
  NOTIFICATION_EDIT: "/notification/edit",
};

export { routeConstant };
